import React from 'react';
import { UtensilsIcon, BeefIcon, ShieldIcon, GiftIcon, CheckCircle2Icon } from 'lucide-react';
export function SystemSection() {
  const elements = [{
    icon: <UtensilsIcon className="w-8 h-8 text-brand-teal" data-id="element-146" />,
    title: 'Base',
    description: 'Carbohidratos y energía que los mantiene activos.'
  }, {
    icon: <BeefIcon className="w-8 h-8 text-brand-teal" data-id="element-147" />,
    title: 'Músculo',
    description: 'Proteína fácil de empacar y deliciosa fría o al tiempo.'
  }, {
    icon: <ShieldIcon className="w-8 h-8 text-brand-teal" data-id="element-148" />,
    title: 'Escudo',
    description: 'Vitaminas y defensas camufladas en frutas y vegetales.'
  }, {
    icon: <GiftIcon className="w-8 h-8 text-brand-teal" data-id="element-149" />,
    title: 'Premio',
    description: 'Ese toque especial que les saca una sonrisa.'
  }];
  const deliverables = ['Guía Principal: El Plan Lonchera Cero Estrés (PDF).', '20 Semanas de Menús: Listos para ejecutar sin pensar.', 'Lista Maestra de Supermercado: Marcas exactas en USA que ahorran tiempo y dinero.', 'El Manual de Sobras Inteligentes: Cómo convertir la cena en un lunch premium.', 'Bonus: Plantillas de "Notas de Amor" para imprimir y poner en su caja.'];
  return <section className="py-20 bg-[#FFFDF9]" data-id="element-150">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-151">
        {/* The Unique Mechanism */}
        <div className="text-center mb-16" data-id="element-152">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-brown mb-6" data-id="element-153">
            El Sistema "Mix & Match" de 10 Minutos
          </h2>
          <p className="text-lg text-brand-brown/80 max-w-3xl mx-auto mb-8" data-id="element-154">
            No es un libro de cocina, es un método de ensamblaje modular. En
            lugar de seguir recetas complejas, aprenderás a combinar 4 elementos
            clave usando productos específicos que ya están en los pasillos de
            Target, Walmart o Aldi.
          </p>
          <div className="inline-block bg-brand-yellow/20 px-6 py-3 rounded-full border border-brand-yellow/50" data-id="element-155">
            <p className="text-xl font-bold text-brand-brown" data-id="element-156">
              Sazón latina con logística americana.
            </p>
          </div>
        </div>

        {/* 4 Elements Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-24" data-id="element-157">
          {elements.map((el, idx) => <div key={idx} className="bg-white p-6 rounded-2xl shadow-sm border border-brand-teal/10 hover:shadow-md transition-shadow flex flex-col items-center text-center" data-id="element-158">
              <div className="w-16 h-16 bg-brand-teal/10 rounded-full flex items-center justify-center mb-4" data-id="element-159">
                {el.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-brown mb-2" data-id="element-160">
                {el.title}
              </h3>
              <p className="text-brand-brown/70 text-sm" data-id="element-161">{el.description}</p>
            </div>)}
        </div>

        {/* What You Get */}
        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-brand-cream" data-id="element-162">
          <div className="bg-brand-coral py-6 px-8 text-center" data-id="element-163">
            <h2 className="text-2xl md:text-3xl font-bold text-white" data-id="element-164">
              ¿Qué incluye?
            </h2>
          </div>
          <div className="p-8 md:p-12" data-id="element-165">
            <ul className="space-y-6" data-id="element-166">
              {deliverables.map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-167">
                  <CheckCircle2Icon className="w-6 h-6 text-brand-teal flex-shrink-0 mt-0.5" data-id="element-168" />
                  <span className="text-lg text-brand-brown font-medium" data-id="element-169">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}